import { uniqueId } from "lodash";

export type SnackBarColors = 'default' | 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'danger'

export class Snackbar {
    public id: string;
    public message: string | null = null;
    public color: SnackBarColors = 'default';
    public duration: number = 15000;

    constructor(message: string, color: SnackBarColors = 'default', duration: number = 3000) {
        this.id = uniqueId('snack_');
        this.message = message;
        this.color = color;
        this.duration = duration;
    }

}

export default Snackbar;